import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { findAppForPath } from "~/pwa/installableApps";
import { recordLastModuleApp } from "~/pwa/lastModuleApp";

const useRecordLastModule = (): void => {
	const { pathname } = useLocation();
	useEffect(() => {
		recordLastModuleApp(findAppForPath(pathname));
	}, [pathname]);
};

export default useRecordLastModule;
